import {trackError} from './3rdParty';

export const copyTextToClipboard = async (text: string) => {
  try {
    await window.navigator.clipboard.writeText(text);
  } catch (error) {
    trackError(new Error('Copy failed'), {extras: {text, error}});
  }
};
